import { Button } from "antd"
import { useDispatch } from "react-redux"
import { Buttons } from "components/Card/Card"
import { FormPage } from "components/Form/Form"
import useOurForm from "components/Form/useForm"
import Message from "components/Message/Message"
import { GenericModal } from "components/Modal/Modal"
import { UpdateVerifyCodeProps } from "types/store"

import styles from "./Profile.module.scss"
import { useLanguage } from "locales"

export const UpdateVerifyCode = (props: UpdateVerifyCodeProps) => {
  const { languages } = useLanguage()
  const formRef = useOurForm()
  const dispatch = useDispatch()

  const inputsObj = [
    {
      name: "twoFa",
      required: true,
      label: languages.twoFa_Titre,
      autoSubmit: true,
      readOnly: true,
    },
  ]

  return (
    <GenericModal visible={props.visible} noFooter>
      <div>
        <Message message={props.message} />
        <div className={styles.Information}>
          {props.type === "email"
            ? languages.verifyEmail
            : languages.verifyPhone}{" "}
          : <b>{props.recipient}</b>
        </div>
        <div style={{ marginTop: "30px" }}>
          <FormPage
            formRef={formRef}
            inputs={inputsObj}
            acceptText={languages.validate}
            cancelText={languages.cancel}
            loading={props.loading}
            onFinish={(values) => {
              const code = (values as any).twoFa
              dispatch({
                type: "UPDATE_VERIFY_REQUEST",
                payload: {
                  token: code,
                  update_verify_id: props.update_verify_id,
                },
              })
              formRef.reset()
            }}
            onCancel={() => {
              dispatch({
                type: "UPDATE_VERIFY_CANCEL",
                payload: { update_verify_id: props.update_verify_id },
              })
              props.cancel()
            }}
          />
        </div>
        <Buttons style={{ paddingTop: 20 }}>
          <Button
            type="link"
            size="small"
            onClick={() =>
              dispatch({
                type: "UPDATE_VERIFY_RESEND",
                payload: {
                  type: props.type,
                  update_verify_id: props.update_verify_id,
                },
              })
            }
          >
            Renvoyer le code
          </Button>
        </Buttons>
      </div>
    </GenericModal>
  )
}
